import { AccountType } from '../../../hoc/types';
import PrimaryAccount from './primary';
import TotalSum from './total-sum';
import { CategoryTypes } from './types';
import formatReportBalance from '../../../hoc/helpers/format-report-balance';

import cn from './reports.module.css';

const ReportCategory = ({
  category,
  itemsVisible,
  withRoute,
  isIncome,
  isSafeguarding,
  search,
  fromPath,
  type,
}: CategoryTypes) => (
  <>
    <div className={cn.reportItem}>
      <div className={cn.reportCategory}>
        <div className={`${cn.reportCategoryValue} ${cn.reportCategoryName}`}>
          <span className={cn.reportNumber}>{category?.number}</span>
          <span>{category?.name}</span>
        </div>
      </div>
      {itemsVisible.includes(AccountType.GROUP) &&
        category?.groups?.map((group) => (
          <div key={group.id}>
            <div className={cn.reportGroup}>
              <div className={`${cn.reportGroupValue} ${cn.reportGroupName}`}>
                <span className={cn.reportNumber}>{group.number}</span>
                <span>{group.description}</span>
              </div>
            </div>
            {itemsVisible.includes(AccountType.PRIMARY_ACCOUNT) &&
              group?.primaries?.map((primary) => (
                <PrimaryAccount
                  fromPath={fromPath}
                  key={primary.id}
                  primary={primary}
                  categoryId={category.id}
                  groupId={group.id}
                  withRoute={withRoute}
                  accountType={category.type}
                  search={search}
                  type={type}
                />
              ))}
            <div className={`${cn.reportPrimary} ${cn.reportPrimaryTotal}`}>
              <div
                className={`${cn.reportPrimaryValue} ${cn.reportPrimaryName} ${cn.total}`}
              >
                <span>Total</span>
              </div>
              <div className={cn.reportPrimaryValue} />
              <div className={cn.reportPrimaryValue}>
                <span>{formatReportBalance(group.total.debitIn)}</span>
              </div>
              <div className={cn.reportPrimaryValue}>
                <span>{formatReportBalance(group.total.creditIn)}</span>
              </div>
              <div className={cn.reportPrimaryValue}>
                <span>{formatReportBalance(group.total.debitTo)}</span>
              </div>
              <div className={cn.reportPrimaryValue}>
                <span>{formatReportBalance(group.total.creditTo)}</span>
              </div>
              <div className={cn.reportPrimaryValue}>
                <span>{formatReportBalance(group.total.debitOut)}</span>
              </div>
              <div className={cn.reportPrimaryValue}>
                <span>{formatReportBalance(group.total.creditOut)}</span>
              </div>
            </div>
          </div>
        ))}
    </div>
    {!isSafeguarding && category?.name && (
      <TotalSum
        title={`Total: ${category?.name}`}
        total={{
          debitIn: category?.total.debitIn || 0,
          creditIn: category?.total.creditIn || 0,
          debitTo: category?.total.debitTo || 0,
          creditTo: category?.total.creditTo || 0,
          debitOut: category?.total.debitOut || 0,
          creditOut: category?.total.creditOut || 0,
        }}
        className={!isIncome ? cn.categoryTotal : ''}
      />
    )}
  </>
);

export default ReportCategory;
